import { AppProviders } from './app/providers';
import { AppRouter } from './routes/AppRouter';

export default function App() {
  return (
    <AppProviders>
      <AppRouter />
    </AppProviders>
  );
}
